// extracted by css-extract-rspack-plugin
export default {"rightRailContainer":"rightRailContainer-VtpvJR","patientDetailsHeader":"patientDetailsHeader-vFFTFh"};